import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateCapacityResult {
  updateEventCapacity: {
    event: {
      id: string;
      maxAttendees: number | null;
    };
    ok: boolean;
  };
}

export interface UpdateCapacityVariables {
  input: {
    eventId: number;
    maxAttendees?: number | null;
  };
}

const UpdateCapacityMutation = gql`
  mutation UpdateEventCapacity($input: UpdateEventCapacityInputType!) {
    updateEventCapacity(input: $input) {
      ok
      event {
        id
        maxAttendees
      }
    }
  }
`;

export const updateCapacity = (
  variables: UpdateCapacityVariables
): Promise<UpdateCapacityResult> => {
  return gqlClient.request<UpdateCapacityResult>(UpdateCapacityMutation, variables);
};
